module.exports = "https://cdn.hellotech.com/client-assets/facebook_ae08bd353e4d0ce852fa2d38dc66da1f.svg";